import ThankfulMessageDesktop from '@/components/welcomeAgainPage/ThankfulMessageDesktop.tsx';
import ThankfulMessageMobile from '@/components/welcomeAgainPage/ThankfulMessageMobile.tsx';
import { useMobileMediaQuery } from '@/utils/useMobileMediaQuery.ts';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix.ts';
import React from 'react';

interface Props {
  onClick: () => void;
}

const WelcomeAgainPage: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslationWithPrefix('views.login');
  const isMobile = useMobileMediaQuery();

  const handleClick = (event: React.FormEvent) => {
    event.preventDefault();
    onClick();
  };

  const ComponentToRender = isMobile ? ThankfulMessageMobile : ThankfulMessageDesktop;
  return (
    <ComponentToRender
      buttonLabel={t('buttons.continue')}
      handleClick={handleClick}
      message={t('welcomeAgain.message')}
      title={t('welcomeAgain.title')}
    />
  );
};

export default WelcomeAgainPage;
